// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1OYKX","item":"PaymentsMobile_item__1T4Za","label":"PaymentsMobile_label__QCXVp","amount":"PaymentsMobile_amount__18-MJ"};